module.exports = __webpack_public_path__ + "static/media/ss-static-vocab-old.26f63d86.png";